import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { PATHS } from '../../constants';
import { getIsEmptyAgreementsPath, getIsExManoTeoLinkActive } from '../../utils/path';
import { MobileMenuItemLink } from '../MobileMenu/MobileMenuItemLink';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentExManoTeo: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);
    const pathname = usePathname();
    const isEmptyAgreementsPath = getIsEmptyAgreementsPath(pathname);
    const customIsActive = isMounted ? getIsExManoTeoLinkActive(item.url, pathname) : false;

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <MobileMenuItemComponentSkeleton />;
    }

    if (isEmptyAgreementsPath && item.url !== PATHS.SEGMENT[TeliaSegment.Fix].dashboard) {
        return null;
    }

    if (isEmptyAgreementsPath && item.url === PATHS.SEGMENT[TeliaSegment.Fix].dashboard) {
        return (
            <MobileMenuItemLink
                item={{ ...item, url: PATHS.SEGMENT[TeliaSegment.Fix].noBusinessAgreements }}
                menuLevel={menuLevel}
                customIsActive={true}
            />
        );
    }

    return <MobileMenuItemLink item={item} menuLevel={menuLevel} customIsActive={customIsActive} />;
};
